mutation DripSequenceStartTriggerSet($input: StartTriggerSetInput!) {
    startTriggerSet(input: $input) {
        campaign {
            id
        }
    }
}
